const COLUMNS = [
  {
    title: "快速浏览",
    links: [
      { href: "#board", label: "热议榜" },
      { href: "#topics", label: "话题广场" },
      { href: "#danmaku", label: "弹幕互动" },
      { href: "#discussion", label: "热门讨论" },
    ],
  },
  {
    title: "更多帮助",
    links: [
      { href: "#about", label: "瓜田学堂" },
      { href: "#faq", label: "常见问题" },
      { href: "#contact", label: "意见反馈" },
    ],
  },
];

const SOCIALS = [
  { icon: "ri-wechat-line", label: "微信公众号" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-douban-line", label: "豆瓣" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
];

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-primary-900 to-primary-950 text-background-200">
      <div className="h-1.5 w-full bg-gradient-to-r from-accent-500 via-secondary-400 to-primary-400"></div>
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#top" className="inline-flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-400 text-lg shadow-sm">🍉</span>
              <span className="font-heading text-2xl text-background-50">
                吾爱<span className="text-secondary-300">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              汇聚全网网友评论与评论区热议，一起吃瓜、一起围观、一起讨论。
              愿每一份快乐都能被分享，愿每一次围观都理性而温暖。
            </p>
            <div className="mt-6 flex items-center gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-primary-400 hover:text-background-50 transition-colors"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-base text-background-50">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-300 hover:text-background-50 transition-colors"
                    >
                      <i className="ri-arrow-right-s-line text-primary-400"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-50/15 pt-6">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 吾爱吃瓜 · 快乐围观，理性讨论
          </p>
          <p className="text-xs text-background-400">
            抵制网络暴力 · 文明上网 · 从我做起
          </p>
        </div>
      </div>
    </footer>
  );
}